module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('p', {
    staticClass: "history__status",
    class: _vm.statusClass
  }, [_vm._v("\n    " + _vm._s(_vm.status)), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "__substatus text-center"
  }, [_vm._v(_vm._s(_vm.substatus))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-94d54b22","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderStatus.vue
// module id = 1203
// module chunks = 0